import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const RouteTracker = () => {
  const location = useLocation();
  const prevHash = useRef(null);

  useEffect(() => {
    const currentHash = window.location.hash;

    if (prevHash.current && prevHash.current !== currentHash) {
      sessionStorage.setItem("previousPath", prevHash.current);
    }

    prevHash.current = currentHash;
  }, [location]);

  return null;
};

export default RouteTracker;
